import Link from "next/link";
import type { DefaultValues } from "react-hook-form";
import type { GiveawayContactFormDataT } from "@/app/schemas/zod/contact-form-schema";
import type {
  ContactFormConfigT,
  ContactFormFieldConfigT,
} from "./contact-form-types";

export type GiveawayContactFormFieldNameT =
  | "salutation"
  | "firstname"
  | "lastname"
  | "email"
  | "phone"
  | "privacy"
  | "mail"
  | "case"
  | "URL"
  | "source"
  | "dealerdesk";

export const giveawayContactFormDefaultValues: DefaultValues<GiveawayContactFormDataT> =
  {
    salutation: undefined,
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    privacy: false,
    mail: "",
    case: "CASE",
    URL: undefined,
    source: "Gewinnspiel Anfrage",
    dealerdesk: "Kontakt Darmstadt",
  };

const primaryFields: ContactFormFieldConfigT<GiveawayContactFormFieldNameT>[] =
  [
    {
      name: "salutation",
      type: "select",
      label: "Anrede *",
      placeholder: "Bitte auswählen...",
      options: [
        { value: "Frau", label: "Frau" },
        { value: "Herr", label: "Herr" },
        { value: "Divers", label: "Divers" },
        { value: "keine-angabe", label: "Keine Angabe" },
      ],
    },
    {
      name: "lastname",
      type: "name",
      label: "Name *",
      placeholder: "Nachname",
    },
    {
      name: "firstname",
      type: "name",
      label: "Vorname *",
      placeholder: "Vorname",
    },
    {
      name: "email",
      type: "text",
      inputType: "email",
      label: "E-Mail *",
      placeholder: "E-Mail",
    },
    {
      name: "phone",
      type: "phone",
      label: "Telefon (optional)",
      placeholder: "Telefon",
    },
  ];

const privacyField: ContactFormFieldConfigT<GiveawayContactFormFieldNameT> = {
  name: "privacy",
  type: "checkbox",
  colSpan: 2,
  label: (
    <span className="text-sm leading-relaxed whitespace-normal sm:whitespace-nowrap">
      Mit absenden bestätigen Sie unsere{" "}
      <Link href="/datenschutz" className="underline">
        Datenschutzerklärung
      </Link>
      .
    </span>
  ),
};

const honeypotField: ContactFormFieldConfigT<GiveawayContactFormFieldNameT> = {
  name: "mail",
  type: "honeypot",
};

const caseField: ContactFormFieldConfigT<GiveawayContactFormFieldNameT> = {
  name: "case",
  type: "select",
  hidden: true,
  options: [
    { value: "CASE", label: "CASE" },
    { value: "OPPORTUNITY", label: "OPPORTUNITY" },
  ],
};

const urlField: ContactFormFieldConfigT<GiveawayContactFormFieldNameT> = {
  name: "URL",
  type: "text",
  hidden: true,
};

export const giveawayContactFormConfig: ContactFormConfigT<GiveawayContactFormFieldNameT> =
  {
    sections: [
      {
        id: "primary",
        layout: "grid",
        columns: 2,
        fields: [...primaryFields, honeypotField, caseField, urlField],
      },
      {
        id: "privacy",
        layout: "grid",
        columns: 2,
        fields: [privacyField],
      },
    ],
    honeypotFieldName: "mail",
    submitButtonLabel: "Nachricht senden",
    submittingLabel: "Wird gesendet...",
    successToast: {
      title: "Vielen Dank für Ihre Teilnahme!",
      description:
        "Wir benachrichtigen die Gewinner*innen per E-Mail oder Telefon.",
    },
    errorToast: {
      title: "Senden fehlgeschlagen",
      description: "Bitte versuchen Sie es erneut.",
    },
  };
